import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const AlarmIcon: React.FC<SvgProps> = ({ width = 13, height = 15, color, ...rest }) => {
  const { theme } = useTheme()
  const fill = color || theme.iconPrimary
  return (
    <Svg width={width} height={height} viewBox="0 0 13 15" fill="none" {...rest}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0C4.63181 0 4.33333 0.298477 4.33333 0.666667C4.33333 1.03486 4.63181 1.33333 5 1.33333H5.66667V2.03467C2.48222 2.3678 0 5.06069 0 8.33333C0 11.8311 2.83553 14.6667 6.33333 14.6667C9.83114 14.6667 12.6667 11.8311 12.6667 8.33333C12.6667 5.06069 10.1844 2.3678 7 2.03467V1.33333H7.66667C8.03486 1.33333 8.33333 1.03486 8.33333 0.666667C8.33333 0.298477 8.03486 0 7.66667 0H5ZM7 5.66667C7 5.29848 6.70152 5 6.33333 5C5.96514 5 5.66667 5.29848 5.66667 5.66667V8.33333C5.66667 8.56751 5.78953 8.78451 5.99034 8.905L7.657 9.905C7.97272 10.0944 8.38223 9.99205 8.57166 9.67633C8.76109 9.36061 8.65872 8.9511 8.343 8.76167L7 7.95587V5.66667Z"
        fill={fill}
      />
      <Path
        d="M10.4147 1.58979C10.675 1.32944 11.0971 1.32944 11.3575 1.58979L12.3575 2.58979C12.6178 2.85014 12.6178 3.27225 12.3575 3.5326C12.0971 3.79295 11.675 3.79295 11.4147 3.5326L10.4147 2.5326C10.1543 2.27225 10.1543 1.85014 10.4147 1.58979Z"
        fill={fill}
      />
      <Path
        d="M2.252 1.58979C2.51235 1.85014 2.51235 2.27225 2.252 2.5326L1.252 3.5326C0.991654 3.79295 0.569544 3.79295 0.309194 3.5326C0.0488449 3.27225 0.0488449 2.85014 0.309194 2.58979L1.30919 1.58979C1.56954 1.32944 1.99165 1.32944 2.252 1.58979Z"
        fill={fill}
      />
    </Svg>
  )
}

export default React.memo(AlarmIcon)
